export const VideoFormat = (url: string) => {
  const videoFormatList = ["mp4", "wmv", "mov", "hevc"];
  const urlSection = url.split("/");
  const fileName = urlSection[urlSection.length - 1].split("?")[0].split(".");
  const extension = fileName[fileName.length - 1];
  return videoFormatList.includes(extension.toLowerCase());
};
